package com.sddamico.draftmachine.models

import kotlinx.serialization.Serializable

/** Frontend mirror of the jvmMain `api/ApiModels.kt` `SuccessResponse`. */
@Serializable
data class SuccessResponse(val message: String)
